import { cn } from "../../lib/utils";
import { useChartTooltipRowContext } from "./ChartTooltipContext";

export interface ChartTooltipValueProps {
  className?: string;
}

/** A row's value, right-aligned and locale-formatted when numeric. Renders 0; hides only undefined. */
export const ChartTooltipValue = ({ className }: ChartTooltipValueProps) => {
  const { value } = useChartTooltipRowContext();
  if (value === undefined) return null;
  return (
    <span
      data-slot="chart-tooltip-value"
      className={cn("text-foreground ml-auto font-mono font-medium tabular-nums", className)}
    >
      {value.toLocaleString()}
    </span>
  );
};
